/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_login_no_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't have an account?`)
};

const zh_hans1_login_no_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`还没有账户？`)
};

const zh_hant1_login_no_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`還沒有帳戶？`)
};

const fr_login_no_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas encore de compte ?`)
};

const de_login_no_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch kein Konto?`)
};

const ja_login_no_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントをお持ちでないですか？`)
};

const ko_login_no_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정이 없으신가요?`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const login_no_account = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.login_no_account(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("login_no_account", locale)
	if (locale === "en") return en_login_no_account(inputs)
	if (locale === "zh-Hans") return zh_hans1_login_no_account(inputs)
	if (locale === "zh-Hant") return zh_hant1_login_no_account(inputs)
	if (locale === "fr") return fr_login_no_account(inputs)
	if (locale === "de") return de_login_no_account(inputs)
	if (locale === "ja") return ja_login_no_account(inputs)
	return ko_login_no_account(inputs)
};